export const emissionClasses = [
  {
    id: '1',
    displayName: 'Euro',
  },
  {
    id: '2',
    displayName: 'Euro',
  },
  {
    id: '3',
    displayName: 'Euro',
  },
  {
    id: '4',
    displayName: 'Euro',
  },
  {
    id: '5',
    displayName: 'Euro',
  },
  {
    id: '6',
    displayName: 'Euro',
  },
]
